<b3-modal [open]="true" overlay size="lg" (b3-close)="close()">
  <b3-modal-header
    [heading]="title"
    aria-level="2"
    close-aria-label="Fechar"
    (b3-close)="close()">
  </b3-modal-header>

  <b3-modal-body>
    <div class="operation-detail-modal__tables">
      <div class="detail-table">
        <div class="detail-table__row detail-table__row--header">
          <div class="detail-table__cell detail-table__cell--header"
            *ngFor="let column of columns"
            [style.flex]="column.flex ? column.flex + ' 1 0' : '1 1 0'">
            {{ column.label }}
          </div>
        </div>
        <div class="detail-table__row detail-table__row--body">
          <div class="detail-table__cell" [style.flex]="columns[0].flex + ' 1 0'">{{ carbonCreditCode }}</div>
          <div class="detail-table__cell" [style.flex]="columns[1].flex + ' 1 0'">{{ creditQuantity }}</div>
          <div class="detail-table__cell" [style.flex]="columns[2].flex + ' 1 0'">{{ emissor }}</div>
          <div class="detail-table__cell" [style.flex]="columns[3].flex + ' 1 0'">{{ detentor }}</div>
          <div class="detail-table__cell" [style.flex]="columns[4].flex + ' 1 0'">{{ comitenteDocumentNumber }}</div>
        </div>
      </div>
    </div>
  </b3-modal-body>

  <b3-modal-footer>
    <b3-button type="button" variant="filled" tone="default" (b3-click)="close()">
      Entendi
    </b3-button>
  </b3-modal-footer>
</b3-modal>
